import { render } from "./ContentWrapper.vue?vue&type=template&id=17bc3bff"
import script from "./ContentWrapper.vue?vue&type=script&lang=js"
export * from "./ContentWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layout/ContentWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17bc3bff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17bc3bff', __exports__)) {
    api.reload('17bc3bff', __exports__)
  }
  
  module.hot.accept("./ContentWrapper.vue?vue&type=template&id=17bc3bff", () => {
    api.rerender('17bc3bff', render)
  })

}


export default __exports__